import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=9138c4ce&scoped=true&"
import script from "./termsofuse.vue?vue&type=script&lang=ts&"
export * from "./termsofuse.vue?vue&type=script&lang=ts&"
import style0 from "./termsofuse.vue?vue&type=style&index=0&id=9138c4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9138c4ce",
  null
  
)

/* custom blocks */
import block0 from "./termsofuse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
